import { Component, Input, OnInit } from '@angular/core';
import {
  BookingTaxEstimateInterface,
  OfferInterface,
} from '@sport-activities/sdk';

import { Subscription } from '~/attendee/model/subscription.model';
import {
  AttendeeGroup,
  splitByAge,
} from '~/core/helpers/attendees/split-by-age.helper';
import { AgeRequirementService } from '~/core/services/activity/age-requirement.service';
import { TaxEstimateService } from '~/checkout/services/tax-estimate/tax-estimate.service';
import isBulgaria from '~/core/helpers/country/country.helper';
import { ParamethorService } from '~/paramethor/paramethor.service';
import { ParamethorNameEnum } from '~/paramethor/names.enum';

@Component({
  selector: 'app-attendee-booking-offers',
  templateUrl: './booking-offers.component.html',
})
export class AttendeeBookingOffersComponent implements OnInit {
  @Input() public subscription: Subscription;

  private attendees: AttendeeGroup;
  public promoCode;
  public taxes: BookingTaxEstimateInterface;
  public isBg: boolean;

  constructor(
    private readonly ageRequirement: AgeRequirementService,
    private readonly taxEstimateService: TaxEstimateService,
    private readonly paramethorService: ParamethorService
  ) {}

  public ngOnInit(): void {
    this.isBg = isBulgaria();
    this.attendees = splitByAge(
      this.subscription?.item?.attendees,
      this.ageRequirement.tenantMajority
    );

    this.taxEstimateService.getTaxes(this.subscription).subscribe((taxes) => {
      this.taxes = taxes;
    });

    this.promoCode = this.subscription?.item?.promotion
      ? this.subscription?.item?.promotion
      : null;
  }

  public get isPromoCodeEnabled() {
    return this.paramethorService.isTrue(
      ParamethorNameEnum.PromoCode
    );
  }

  get adultsTotalPrice(): number {
    return this.subscription?.item.price * this.numberOfAdults;
  }

  get childrenTotalPrice(): number {
    return this.subscription?.item.price * this.numberOfChildren;
  }

  get numberOfAdults(): number {
    return this.attendees.adults.length;
  }

  get numberOfChildren(): number {
    return this.attendees.children.length;
  }

  get offer(): OfferInterface {
    return this.subscription?.timeslot?.offers?.find(
      (offer) => offer.identifier === this.subscription?.item.offerIdentifier
    );
  }

  get totalPrice(): number {
    if (this.isPromoCodeEnabled && this.promoCode) {
      return this.promoCode.finalPrice;
    }
    return this.adultsTotalPrice + this.childrenTotalPrice;
  }
}
